import { LoadScriptResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ResourcesInstancesControllerModule } from './controllers/ResourcesInstancesController';

export const ResourcesInstancesView = angular
  .module('acme.view.application.resources.instances', [uiRouter, 'ui.bootstrap', ResourcesInstancesControllerModule])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.resourcesInstances',
      url: '/resources/instances/:id',
      views: {
        'subview-main': {
          controller: 'ResourcesInstancesController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/resources/instances/instances.tpl.html',
        },
      },
      data: {
        pageTitle: 'View Resource',
        rule: function (permits) {
          // Allow if state is not in exclusions array
          return permits.indexOf('application.resources.instances') !== -1;
        },
      },
      resolve: {
        jqueryUI: LoadScriptResolver({ id: 'jquery-ui', url: '/assets/jquery-ui.custom.min.js' }),
        fullcalendar: LoadScriptResolver({ id: 'fullcalendar', url: '/assets/fullcalendar.js' }),
      },
    });
  }).name;
